import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CONNECT_STATUS } from 'constants/profile';

import './styles.css';

const ConnectionsItemStatus = props => {
  const { status, onClick } = props;

  return useMemo(() => {
    if (CONNECT_STATUS.CONNECTED === status) {
      return (
        <span
          className="connections-block__item-cta"
          onClick={() => onClick('message')}
        >
          Message
        </span>
      );
    }

    if (CONNECT_STATUS.REQUIRE_APPROVE === status) {
      return <span className="connections-block__item-pending">Pending</span>;
    }

    if (CONNECT_STATUS.REQUIRE_ACTION === status) {
      return (
        <>
          <span
            className="connections-block__item-cta"
            onClick={() => onClick('accept')}
          >
            Accept
          </span>
          <span
            className="connections-block__item-reject"
            onClick={() => onClick('reject')}
          >
            Reject
          </span>
        </>
      );
    }

    if (CONNECT_STATUS.NOT_CONNECTED === status) {
      return (
        <span
          className="connections-block__item-cta"
          onClick={() => onClick('connect')}
        >
          Connect
        </span>
      );
    }

    return null;
  }, [status, onClick]);
};

ConnectionsItemStatus.propTypes = {
  status: PropTypes.oneOf([
    CONNECT_STATUS.REQUIRE_APPROVE,
    CONNECT_STATUS.NOT_CONNECTED,
    CONNECT_STATUS.CONNECTED,
    CONNECT_STATUS.REQUIRE_ACTION,
  ]),
  onClick: PropTypes.func,
};

export default ConnectionsItemStatus;
